import styled from 'styled-components';
import {Space} from 'antd';
import DashboardPageTransition from '../../components/animations/DashboardPageTransition';

const PREVIEW_PANEL_WIDTH = '54.18%';

const StyledInvoicePageContainer = styled(DashboardPageTransition)`
  overflow-x: hidden;
  padding: 24px 0 24px 24px;
`;

const StyledInvoicePageContainerSpace = styled(Space)`
  width: 100%;
  & > .ant-space-item {
    &:nth-of-type(1) {
      min-width: ${PREVIEW_PANEL_WIDTH};
      width: ${PREVIEW_PANEL_WIDTH};
      
      .ant-card-body {
        height: calc(100vh - 66px - 56px - 52px);
        overflow: auto;
      }
    } 
    &:nth-of-type(2) {
      width: calc(100% - ${PREVIEW_PANEL_WIDTH} - 48px);
      .ant-space {
        width: 100%;
      }
    }
    & > div > .ant-card {
      height: calc(100vh - 66px - 48px);
      
      .ant-card-body {
        overflow: auto;
        max-height: calc(100% - 55px);
      }
      
      .ant-card-head {
        position: sticky;
        top: 0;
        z-index: 4;
      }
    }
  }
`;


export {
  StyledInvoicePageContainer,
  StyledInvoicePageContainerSpace,
};
